import React from 'react';
import classnames from 'classnames';
import { ToggleButton, Slider } from './Toggle.styles';

type OwnProps = {
  dataQa?: string;
  disabled?: boolean;
  onClick?: () => void;
  value: boolean;
};

const Toggle = ({ value, onClick, disabled = false, dataQa }: OwnProps) => {
  const sliderClassName = classnames({ slider: true, 'is-on': value });
  const handleOnClick = () => {
    if (disabled) return;
    onClick?.();
  };

  return (
    <ToggleButton
      data-testid="toggle"
      aria-checked={value}
      aria-readonly={disabled}
      disabled={disabled}
      isOn={value}
    >
      <input data-qa={dataQa} type="checkbox" checked={value} readOnly />
      <Slider className={sliderClassName} onClick={handleOnClick} disabled={disabled} />
    </ToggleButton>
  );
};

export default Toggle;
